import cx from 'classnames';
import { FC, ReactElement } from 'react';

import SearchVacancies from '../SearchVacancies';
import { Container } from '../UI/Container';
import classes from './HeroBlock.module.scss';
import { HeroBlockProps } from './HeroBlock.types';

export const HeroBlockCatalog: FC<HeroBlockProps> = ({ className }): ReactElement => (
  <div className={cx(classes['hero-block'], className)}>
    <Container className={classes['hero-block__container']}>
      <SearchVacancies isCatalog />
    </Container>
  </div>
);
